import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { saveUserData, isStudent } from '../utils/auth';
import './Login.css';

function Login() {
  const hideStudentRegister = isStudent();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error on input change
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Call login API with UserName (email) and Password
      const response = await authService.login(formData.email, formData.password);
      
      if (response) {
        // Handle both Role and role (API might return Role with capital R)
        const role = response.Role || response.role;
        
        // Store user data in localStorage
        saveUserData({
          token: response.Token || response.token,
          role: role,
          userId: response.UserId || response.userId,
          id: response.Id || response.id,
          userName: response.UserName || response.userName,
          name: response.Name || response.name,
          mobileNo: response.MobileNo || response.mobileNo,
          email: response.Email || response.email,
          address: response.Address || response.address,
          code: response.Code || response.code,
          isBlocked: response.IsBlocked || response.isBlocked,
          cordinatorId: response.CordinatorId || response.cordinatorId,
          collegeId: response.CollegeId || response.collegeId,
          studentId: response.StudentId || response.studentId,
          companyId: response.CompanyId || response.companyId
        });

        // Check if user is blocked
        const isBlocked = response.IsBlocked || response.isBlocked;
        if (isBlocked) {
          setError('Your account has been blocked. Please contact administrator.');
          setLoading(false);
          return;
        }

        // Navigate based on role from API response
        const roleLower = (role || '').toLowerCase();
        if (roleLower === 'admin') {
          navigate('/admin');
        } else if (roleLower === 'company') {
          navigate('/company-portal');
        } else if (roleLower === 'cordinator') {
          navigate('/coordinator-portal');
        } else if (roleLower === 'student') {
          navigate('/');
        } else {
          navigate('/');
        }
      } else {
        setError('Invalid username or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed. Please check your credentials and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Welcome Back</h1>
          <p>Login to your account</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Username / Email</label>
            <input
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your username or email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
            />
          </div>

          <div className="form-options">
            <label className="remember-me">
              <input type="checkbox" />
              <span>Remember me</span>
            </label>
            <Link to="#" className="forgot-password">Forgot Password?</Link>
          </div>

          {error && (
            <div className="error-message" style={{ 
              color: '#dc3545', 
              padding: '0.8rem', 
              backgroundColor: '#f8d7da', 
              borderRadius: '5px',
              border: '1px solid #f5c6cb'
            }}>
              {error}
            </div>
          )}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div className="register-link">
            <p>Don&apos;t have an account? {!hideStudentRegister && <><Link to="/student-register">Register as Student</Link> or </>}<Link to="/company-register">Register as Company</Link></p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;

